<div class="manage-prospect" *ngIf="!loading">
    <page-header
        [titleText]="this.getBusinessName()"
        [shortBottomPadding]="true"
        backButtonText="Back To Prospects"
        (handleBackButtonClick)="navigateToProspectsPage()"
    >
    </page-header>
    <div class="container-fluid page-container">
        <tabs [tabsConfig]="tabsConfig$"></tabs>
        <router-outlet></router-outlet>
    </div>
</div>
<div *ngIf="loading">
    <lsq-circle-loader></lsq-circle-loader>
</div>
